var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 19H18","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M12 16L12 5","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","key":1}),React.createElement("path",{"d":"M16 12.5L12 16.5L8 12.5","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","key":2})]);
}

Download.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Download;

Download.default = Download;
